import {
  deleteCookie as nextDeleteCookie,
  setCookie as nextSetCookie,
} from 'cookies-next';

export const helpHubStoreCookieName = 'help_hub_store_id';

// `SameSite=None; Secure` is required so the cookie is set and subsequently
// sent when the app runs as a third-party iframe inside Microsoft Teams.
// `Lax` (the default) prevents the browser from including app-set cookies
// like the store-id on cross-site navigations from the Teams host frame,
// which leaves the user looping on /select-store.
//
// However, the `Secure` flag is silently rejected by browsers on insecure
// (HTTP) origins, so when running locally over plain http we fall back to
// the cookies-next defaults — mirroring the approach used by NextAuth in
// `auth/auth.ts`, which only applies the cross-site cookie overrides when
// serving over HTTPS.
const crossSiteCookieOptions = {
  sameSite: 'none',
  secure: true,
  path: '/',
} as const;

const defaultCookieOptions = { path: '/' } as const;

const getCookieOptions = () => {
  // `setCookie`/`deleteCookie` are only invoked from client components, so
  // `window` is available here. Guard for SSR / tests just in case.
  if (typeof window === 'undefined') {
    return crossSiteCookieOptions;
  }

  if (window.location.protocol === 'https:') {
    return crossSiteCookieOptions;
  }

  return defaultCookieOptions;
};

export const setCookie = (name: string, value: string | boolean) => {
  void nextSetCookie(name, value, getCookieOptions());
};

export const deleteCookie = (name: string) => {
  void nextDeleteCookie(name, getCookieOptions());
};
